import gql from 'graphql-tag';
import client from '../../client';
export const CREATE_USER = gql `
  mutation CreateUser($input: CreateUserInput!) {
    createdUser(input: $input) @rest(type: "CreateUserResult", path: "internal/users", method: "POST") {
      data {
        id
        country
        countryCode
        createdAt
        updatedAt
        externalId
        familyName
        givenName
        email
      }
    }
  }
`;
export const createUser = (accountId) => {
    return client.mutate({
        mutation: CREATE_USER,
        variables: {
            input: { externalId: accountId },
        },
    });
};
export default createUser;
